import posed from 'react-pose';

export const VideoWrapperPosed = posed.div({
  enter: { opacity: 1, transition: { opacity: { duration: 400 } } },
  exit: { opacity: 0, transition: { opacity: { duration: 200 } } },
});
